import { project } from '@/+state';

export const userAccessToken = project<string>(
  ({ stores }) => stores.userStore.accessToken,
);

export const userProjections = [userAccessToken];
